import { combineReducers } from 'redux';
import root from './rootReducer';

const rootReducer = combineReducers({
  root,
});

export default rootReducer;
